// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.country-graph .apexcharts-tooltip {
  box-shadow: none !important;
  border: none !important;
  background: none !important;
  overflow: visible !important;
  color: var(--gray_dark2);
}
.country-graph .apexcharts-tooltip .CountryGraph-customTooltip {
  border: 1px solid var(--gray_light2);
  background: var(--base_color2);
  border-radius: 5px;
  box-shadow: 2px 2px 6px -4px var(--gray);
  cursor: default;
  font-size: 14px;
  pointer-events: none;
  overflow: hidden;
  white-space: nowrap;
  z-index: 10;
  transition: 0.15s ease all;
  position: relative;
  height: 100%;
  width: 100%;
  transform: translate(0, 0);
}
.country-graph .apexcharts-tooltip .CountryGraph-customTooltip-country {
  padding: 6px;
  font-size: 15px;
  margin-bottom: 4px;
  background: var(--gray_light2);
  border-bottom: 1px solid var(--gray_light1);
}
.country-graph .apexcharts-tooltip .CountryGraph-customTooltip-series-group {
  padding: 0 6px;
  text-align: left;
  justify-content: left;
  align-items: center;
}
.country-graph .apexcharts-tooltip .CountryGraph-customTooltip-series-group .CountryGraph-customTooltip-percent {
  padding-bottom: 4px;
}
.country-graph .apexcharts-tooltip .CountryGraph-customTooltip-series-group .CountryGraph-customTooltip-percent-percent-label {
  text-transform: capitalize;
}
.country-graph .apexcharts-tooltip .CountryGraph-customTooltip-series-group .CountryGraph-customTooltip-percent-percent-label, .country-graph .apexcharts-tooltip .CountryGraph-customTooltip-series-group .CountryGraph-customTooltip-percent-percent-value {
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/components/CountryGraph/index.scss"],"names":[],"mappings":"AACE;EACE,2BAAA;EACA,uBAAA;EACA,2BAAA;EACA,4BAAA;EACA,wBAAA;AAAJ;AACI;EACE,oCAAA;EACA,8BAAA;EACA,kBAAA;EACA,wCAAA;EACA,eAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,0BAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,0BAAA;AACN;AAAM;EACE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,8BAAA;EACA,2CAAA;AAER;AACM;EACE,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;AACR;AACQ;EACE,mBAAA;AACV;AAAU;EACE,0BAAA;AAEZ;AACU;EAEE,gBAAA;AAAZ","sourcesContent":[".country-graph {\n  .apexcharts-tooltip {\n    box-shadow: none !important;\n    border: none !important;\n    background: none !important;\n    overflow: visible !important;\n    color: var(--gray_dark2);\n    .CountryGraph-customTooltip {\n      border: 1px solid var(--gray_light2);\n      background: var(--base_color2);\n      border-radius: 5px;\n      box-shadow: 2px 2px 6px -4px var(--gray);\n      cursor: default;\n      font-size: 14px;\n      pointer-events: none;\n      overflow: hidden;\n      white-space: nowrap;\n      z-index: 10;\n      transition: 0.15s ease all;\n      position: relative;\n      height: 100%;\n      width: 100%;\n      transform: translate(0, 0);\n      &-country {\n        padding: 6px;\n        font-size: 15px;\n        margin-bottom: 4px;\n        background: var(--gray_light2);\n        border-bottom: 1px solid var(--gray_light1);\n      }\n\n      &-series-group {\n        padding: 0 6px;\n        text-align: left;\n        justify-content: left;\n        align-items: center;\n\n        .CountryGraph-customTooltip-percent {\n          padding-bottom: 4px;\n          &-percent-label {\n            text-transform: capitalize;\n          }\n\n          &-percent-label,\n          &-percent-value {\n            font-weight: 600;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
